import { useState } from 'react';

const useCloseableAlertState = (storageKey: string) => {
  const [isOpen, setIsOpen] = useState(localStorage.getItem(storageKey) !== 'true');

  const onClose = () => {
    localStorage.setItem(storageKey, 'true');
    setIsOpen(false);
  };

  return {
    isOpen,
    onClose,
  };
};

export default useCloseableAlertState;
